import { schema } from "normalizr";

const schadstoffSchema = new schema.Entity(
  "schadstoff",
  {},
  { idAttribute: "id" }
);

export { schadstoffSchema };
